function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 8l3.565-1.837-1.222-3.82 3.82 1.222L8 0l1.837 3.565 3.82-1.222-1.222 3.82L16 8l-3.565 1.837 1.222 3.82-3.82-1.222L8 16l-1.837-3.565-3.82 1.222 1.222-3.82L0 8z",
  fill: "#45CA52"
});

function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTS0zLjQ5NjkxZS0wNyA4TDMuNTY1MzggNi4xNjMxMkwyLjM0MzE1IDIuMzQzMTVMNi4xNjMxMiAzLjU2NTM4TDggLTMuNDk2OTFlLTA3TDkuODM2ODggMy41NjUzOEwxMy42NTY5IDIuMzQzMTRMMTIuNDM0NiA2LjE2MzEyTDE2IDhMMTIuNDM0NiA5LjgzNjg4TDEzLjY1NjkgMTMuNjU2OUw5LjgzNjg4IDEyLjQzNDZMOCAxNkw2LjE2MzEyIDEyLjQzNDZMMi4zNDMxNSAxMy42NTY5TDMuNTY1MzggOS44MzY4OEwtMy40OTY5MWUtMDcgOFoiIGZpbGw9IiM0NUNBNTIiLz4KPC9zdmc+Cg==";
export { SvgNew as ReactComponent };